<template>
 <div class="aside-p">
   <div class="aside-cover-p" @click="scrollToCover">
     <div></div>
     <p>封面</p>
   </div>
   <div class="aside-quality-p" @click="scrollToQuality">
     <div></div>
     <p>质量安全</p>
   </div>
   <div class="aside-material-p" @click="scrollToMaterial">
     <div></div>
     <p>材料安全</p>
   </div>
   <div class="aside-top-p" @click="scrollToTop">
     <img src="../../../../../html/pages/originality/createQe/images/arrow1.png" alt="">
   </div>
 </div>
</template>

<script>
import "../../../../../html/components/createQE/asideRight.scss";

 export default {
   name: 'asideRight',
   data () {
     return {

     }
   },
   methods:{
     scrollToCover(){
       this.$emit("scrollToCover")
     },
     scrollToQuality(){
       this.$emit("scrollToQuality")
     },
     scrollToMaterial(){
       this.$emit("scrollToMaterial")
     },
     scrollToTop(){
       this.$emit("scrollToTop")
     }
   }
 }
</script>
